import en from "./en.json";
import { SFLanguages as coreResources } from "@sf-core";
import { languages as launchpadResources } from "../areas/launchPad";
import _ from "lodash";

export const translations = {
  ..._.merge({ en }, coreResources, launchpadResources),
};
